// ------------------------------------------------------------------
// Translations for the structure story (About), Partner Spotlight and the
// /markets/:slug landing pages. Merged over the locale files in i18n/index.js.
//
// Grammar note: country names are injected with {country}. To avoid wrong case
// endings in inflected languages (pl/fi/de/etc.) every heading uses a dash or
// colon pattern — "Zakresy projektów — Polska" — instead of a preposition.
// ------------------------------------------------------------------

const L = (o) => ({
  structure: {
    label: o.sLabel,
    title: o.sTitle,
    lead: o.sLead,
    layers: [
      { id: "hq", n: "01", title: o.l1t, text: o.l1x },
      { id: "departments", n: "02", title: o.l2t, text: o.l2x },
      { id: "network", n: "03", title: o.l3t, text: o.l3x },
    ],
    flow: o.flow,
    deptPartner: o.deptPartner,
    deptHq: o.deptHq,
    orgCta: o.orgCta,
    networkCta: o.networkCta,
  },
  partners: { partnerDepts: o.partnerDepts },
  orgDepts: {
    operations: { title: o.d[0][0], tagline: o.d[0][1] },
    manpower: { title: o.d[1][0], tagline: o.d[1][1] },
    hse: { title: o.d[2][0], tagline: o.d[2][1] },
    recruitment: { title: o.d[3][0], tagline: o.d[3][1] },
    finance: { title: o.d[4][0], tagline: o.d[4][1] },
    business: { title: o.d[5][0], tagline: o.d[5][1] },
  },
  partnersPage: { about: { label: o.aLabel, title: o.aTitle, p1: o.p1, p2: o.p2 } },
  org: { lead: o.orgLead },
  spotlight: { label: o.spLabel, title: o.spTitle, lead: o.spLead, whatsapp: o.spWa },
  markets: { viewMarket: o.viewMarket },
  marketPage: {
    kicker: o.mKicker,
    titlePrefix: o.mPrefix,
    factsTitle: o.mFacts,
    facts: {
      coverage: o.fCoverage, coverageText: o.fCoverageT, contactLabel: o.fContact,
      hqLabel: o.fHq, hqText: o.fHqT, languages: o.fLang, languagesText: o.fLangT,
    },
    servicesTitle: o.mServices,
    services: o.services,
    contactTitle: o.mContactT,
    contactLead: o.mContactL,
    enquiryCta: o.mCta,
    mapCta: o.mMapCta,
    disclaimer: o.mDisc,
    projectsLabel: o.pLabel,
    projectsTitle: o.pTitle,
    projectsLead: o.pLead,
    rolesTitle: o.rTitle,
    rolesWhite: o.rWhite,
    rolesBlue: o.rBlue,
    industriesTitle: o.iTitle,
  },
});

const sv = L({
  d: [
    ["Verksamhet & projekt", "Vi levererar projekt med kvalitet"],
    ["Bemanning", "Vi tillsätter rätt personer"],
    ["HSE & kvalitet", "Säkerhet · Kvalitet · Regelefterlevnad"],
    ["Rekrytering & talent acquisition", "Söka. Granska. Tillsätta."],
    ["Ekonomi & administration", "Finansiell styrka. Operativt stöd."],
    ["Affärsutveckling", "Vi bygger relationer och skapar möjligheter"],
  ],
  sLabel: "Så är vi organiserade",
  sTitle: "En struktur, tre nivåer",
  sLead: "Varje förfrågan följer samma väg: den ägs av vårt huvudkontor i Sandviken, hanteras av en av sex funktionsavdelningar och levereras lokalt genom vårt internationella partnernätverk.",
  l1t: "Huvudkontor — Sandviken, Sverige",
  l1x: "Ledning, avtal och kundansvar ligger hos VD i Sverige. Varje uppdrag har en ansvarig ägare.",
  l2t: "Sex funktionsavdelningar",
  l2x: "Verksamhet & projekt, bemanning, HSE & kvalitet, rekrytering & talent acquisition, ekonomi & administration samt affärsutveckling.",
  l3t: "Internationellt partnernätverk",
  l3x: "Namngivna partners täcker Storbritannien, Portugal, Polen, Norden och Saudiarabien — lokal marknadskunskap och lokalt språk, ett avtal med The Nordic Vision.",
  flow: ["Kundförfrågan", "Ansvar på huvudkontoret", "Avdelningen hanterar", "Lokal partner levererar", "Mobilisering på plats"],
  deptPartner: "Partneransvar",
  deptHq: "Huvudkontor",
  orgCta: "Se de sex avdelningarna",
  networkCta: "Möt partnernätverket",
  partnerDepts: "Avdelningar som stöds",
  aLabel: "Om nätverket",
  aTitle: "Så fungerar vår internationella struktur",
  p1: "The Nordic Vision är ett svenskt företag med ett tydligt ansvarigt huvudkontor i Sandviken. Arbetet är organiserat i sex avdelningar — verksamhet & projekt, bemanning, HSE & kvalitet, rekrytering & talent acquisition, ekonomi & administration samt affärsutveckling — och varje avdelning stöds internationellt av en namngiven partner.",
  p2: "Det ger dig lokal marknadskunskap och lokalt språk på varje marknad vi arbetar på, en ansvarig kontaktpunkt i Sverige och ett avtal med The Nordic Vision. Våra partners täcker affärsutveckling, bemanningslösningar, HSE, rekrytering och projektdrift i Europa, Storbritannien, Portugal, Polen, Norden och utvalda internationella marknader.",
  orgLead: "Nivå två i vår struktur: sex funktionsavdelningar på huvudkontoret i Sandviken. Varje avdelning äger en tydlig del av ditt uppdrag och stöds internationellt av en namngiven partner från vårt nätverk.",
  spLabel: "Partners i fokus",
  spTitle: "Prata direkt med partnern för din marknad",
  spLead: "Varje marknad har en namngiven partner. Skriv direkt på WhatsApp — inga formulär, ingen kundtjänstkö.",
  spWa: "WhatsApp {name}",
  viewMarket: "Marknadssida",
  mKicker: "Marknad",
  mPrefix: "Bemanning & industriella tjänster —",
  mFacts: "Kort om marknaden",
  fCoverage: "Omfattning",
  fCoverageT: "Tjänstemän & yrkesarbetare, HSE-stöd",
  fContact: "Lokal kontakt",
  fHq: "Huvudkontor",
  fHqT: "Sandviken, Sverige",
  fLang: "Arbetsspråk",
  fLangT: "Engelska + lokalt språk",
  mServices: "Detta erbjuder vi — {country}",
  services: [
    { title: "Tjänstemän & specialister", text: "HSE- och SHEQ-specialister, projekt- och platsledning, teknik, kvalitet, planering och projektstyrning för projekt på denna marknad." },
    { title: "Certifierade yrkesarbetare", text: "Certifierade yrken för bygg, anläggning, mekanik, el, stål och specialiserade finisharbeten — mobiliserade för projekt på denna marknad." },
    { title: "HSE-konsultstöd", text: "HSE-konsultation enligt ISO 45001:2018, dokumentation och stöd på plats för kunder som är verksamma på denna marknad." },
  ],
  mContactT: "Lokal kontakt — {country}",
  mContactL: "Berätta om ditt behov på denna marknad — via telefon, WhatsApp eller e-post. Förfrågningar går till den partner som ansvarar för marknaden.",
  mCta: "Begär arbetskraft — {country}",
  mMapCta: "Se alla marknader på kartan",
  mDisc: "The Nordic Vision arbetar från sitt huvudkontor i Sandviken, Sverige och stöder kunder på denna marknad ({country}) genom sitt eget team och ett internationellt partnernätverk. Vi påstår inte att vi har fysiska kontor utanför Sverige.",
  pLabel: "Typiska uppdrag",
  pTitle: "Projektomfattningar vi stödjer — {country}",
  pLead: "Exempel på arbete som våra tjänstemän och yrkesarbetare normalt stödjer på denna marknad. Detta är typiska uppdragstyper, inte kundreferenser.",
  rTitle: "Roller vi mobiliserar — {country}",
  rWhite: "Tjänstemän & tekniska roller",
  rBlue: "Yrkesarbetare & roller på plats",
  iTitle: "Branscher vi arbetar med — {country}",
});

const pt = L({
  d: [
    ["Operações & projetos", "Entregar projetos com excelência"],
    ["Fornecimento de mão de obra", "Colocar as pessoas certas"],
    ["HSE & qualidade", "Segurança · Qualidade · Conformidade"],
    ["Recrutamento & aquisição de talento", "Procurar. Avaliar. Colocar."],
    ["Finanças & administração", "Solidez financeira. Apoio operacional."],
    ["Desenvolvimento de negócio", "Criar relações e novas oportunidades"],
  ],
  sLabel: "Como estamos organizados",
  sTitle: "Uma estrutura, três camadas",
  sLead: "Cada pedido segue o mesmo caminho: é assumido pela nossa sede em Sandviken, tratado por um dos seis departamentos funcionais e entregue localmente através da nossa rede internacional de parceiros.",
  l1t: "Sede — Sandviken, Suécia",
  l1x: "A liderança, os contratos e a responsabilidade pelo cliente estão com o Diretor-Geral / CEO na Suécia. Cada projeto tem um responsável único.",
  l2t: "Seis departamentos funcionais",
  l2x: "Operações & projetos, fornecimento de mão de obra, HSE & qualidade, recrutamento & aquisição de talento, finanças & administração e desenvolvimento de negócio.",
  l3t: "Rede internacional de parceiros",
  l3x: "Parceiros identificados cobrem o Reino Unido, Portugal, a Polónia, a região nórdica e a Arábia Saudita — conhecimento e língua local, um único contrato com a The Nordic Vision.",
  flow: ["Pedido do cliente", "Responsabilidade da sede", "Tratamento pelo departamento", "Entrega pelo parceiro local", "Mobilização em obra"],
  deptPartner: "Parceiro responsável",
  deptHq: "Sede",
  orgCta: "Ver os seis departamentos",
  networkCta: "Conhecer a rede de parceiros",
  partnerDepts: "Departamentos apoiados",
  aLabel: "Sobre a rede",
  aTitle: "Como funciona a nossa estrutura internacional",
  p1: "A The Nordic Vision é uma empresa sueca com uma única sede responsável em Sandviken. O trabalho está organizado em seis departamentos — operações & projetos, fornecimento de mão de obra, HSE & qualidade, recrutamento & aquisição de talento, finanças & administração e desenvolvimento de negócio — e cada departamento é apoiado internacionalmente por um parceiro identificado.",
  p2: "Isso garante conhecimento e língua local em cada mercado onde atuamos, um único ponto de responsabilidade na Suécia e um único contrato com a The Nordic Vision. Os nossos parceiros cobrem desenvolvimento de negócio, soluções de mão de obra, HSE, recrutamento e operações de projeto na Europa, Reino Unido, Portugal, Polónia, região nórdica e mercados internacionais selecionados.",
  orgLead: "Camada dois da nossa estrutura: seis departamentos funcionais na sede em Sandviken. Cada departamento é responsável por uma parte clara do seu projeto e é apoiado internacionalmente por um parceiro identificado da nossa rede.",
  spLabel: "Parceiros em destaque",
  spTitle: "Fale diretamente com o parceiro do seu mercado",
  spLead: "Cada mercado tem um parceiro identificado. Envie mensagem diretamente por WhatsApp — sem formulários, sem call center.",
  spWa: "WhatsApp {name}",
  viewMarket: "Página do mercado",
  mKicker: "Mercado",
  mPrefix: "Mão de obra & serviços industriais —",
  mFacts: "Resumo",
  fCoverage: "Cobertura",
  fCoverageT: "Profissionais e mão de obra qualificada, apoio HSE",
  fContact: "Contacto local",
  fHq: "Sede",
  fHqT: "Sandviken, Suécia",
  fLang: "Línguas de trabalho",
  fLangT: "Inglês + língua local",
  mServices: "O que disponibilizamos — {country}",
  services: [
    { title: "Profissionais e quadros técnicos", text: "Especialistas de HSE e SHEQ, direção de obra e de projeto, engenharia, qualidade, planeamento e controlo de projeto para projetos neste mercado." },
    { title: "Mão de obra qualificada e certificada", text: "Profissões certificadas para construção, indústria, mecânica, elétrica, estrutura metálica e acabamentos especializados — mobilizadas para projetos neste mercado." },
    { title: "Apoio de consultoria HSE", text: "Consultoria HSE alinhada com a ISO 45001:2018, documentação e apoio em obra para clientes que operam neste mercado." },
  ],
  mContactT: "Contacto local — {country}",
  mContactL: "Fale connosco sobre uma necessidade neste mercado — por telefone, WhatsApp ou email. Os pedidos são encaminhados para o parceiro responsável.",
  mCta: "Solicitar mão de obra — {country}",
  mMapCta: "Ver todos os mercados no mapa",
  mDisc: "A The Nordic Vision opera a partir da sua sede em Sandviken, na Suécia, e apoia clientes neste mercado ({country}) através da sua própria equipa e de uma rede internacional de parceiros. Não é reivindicado qualquer escritório físico fora da Suécia.",
  pLabel: "Âmbitos típicos",
  pTitle: "Âmbitos de projeto que apoiamos — {country}",
  pLead: "Exemplos do trabalho que os nossos profissionais e mão de obra qualificada normalmente apoiam neste mercado. São âmbitos típicos, não referências de clientes.",
  rTitle: "Funções que mobilizamos — {country}",
  rWhite: "Funções profissionais e técnicas",
  rBlue: "Profissões qualificadas e funções de obra",
  iTitle: "Setores que servimos — {country}",
});

const pl = L({
  d: [
    ["Operacje i projekty", "Realizujemy projekty na najwyższym poziomie"],
    ["Dostarczanie kadr", "Zapewniamy właściwych ludzi"],
    ["BHP i jakość", "Bezpieczeństwo · Jakość · Zgodność"],
    ["Rekrutacja i pozyskiwanie talentów", "Szukamy. Weryfikujemy. Zatrudniamy."],
    ["Finanse i administracja", "Stabilność finansowa. Wsparcie operacyjne."],
    ["Rozwój biznesu", "Budujemy relacje i tworzymy możliwości"],
  ],
  sLabel: "Jak jesteśmy zorganizowani",
  sTitle: "Jedna struktura, trzy poziomy",
  sLead: "Każde zapytanie przechodzi tę samą drogę: odpowiada za nie nasza siedziba w Sandviken, obsługuje je jeden z sześciu działów funkcyjnych, a realizacja odbywa się lokalnie przez naszą międzynarodową sieć partnerów.",
  l1t: "Siedziba — Sandviken, Szwecja",
  l1x: "Zarządzanie, umowy i odpowiedzialność za klienta należą do Dyrektora Zarządzającego / CEO w Szwecji. Każde zlecenie ma jednego właściciela.",
  l2t: "Sześć działów funkcyjnych",
  l2x: "Operacje i projekty, dostarczanie kadr, BHP i jakość, rekrutacja i pozyskiwanie talentów, finanse i administracja oraz rozwój biznesu.",
  l3t: "Międzynarodowa sieć partnerów",
  l3x: "Wskazani partnerzy obsługują Wielką Brytanię, Portugalię, Polskę, region nordycki i Arabię Saudyjską — lokalna znajomość rynku i języka, jedna umowa z The Nordic Vision.",
  flow: ["Zapytanie klienta", "Odpowiedzialność siedziby", "Obsługa przez dział", "Realizacja przez partnera lokalnego", "Mobilizacja na budowie"],
  deptPartner: "Opieka partnera",
  deptHq: "Siedziba",
  orgCta: "Zobacz sześć działów",
  networkCta: "Poznaj sieć partnerów",
  partnerDepts: "Wspierane działy",
  aLabel: "O sieci",
  aTitle: "Jak działa nasza międzynarodowa struktura",
  p1: "The Nordic Vision to szwedzka firma z jedną odpowiedzialną siedzibą w Sandviken. Praca jest zorganizowana w sześciu działach — operacje i projekty, dostarczanie kadr, BHP i jakość, rekrutacja i pozyskiwanie talentów, finanse i administracja oraz rozwój biznesu — a każdy dział jest wspierany międzynarodowo przez wskazanego partnera.",
  p2: "Dzięki temu masz lokalną znajomość rynku i języka na każdym obsługiwanym rynku, jeden punkt odpowiedzialności w Szwecji i jedną umowę z The Nordic Vision. Nasi partnerzy obejmują rozwój biznesu, rozwiązania kadrowe, BHP, rekrutację i operacje projektowe w Europie, Wielkiej Brytanii, Portugalii, Polsce, regionie nordyckim i na wybranych rynkach międzynarodowych.",
  orgLead: "Poziom drugi naszej struktury: sześć działów funkcyjnych w siedzibie w Sandviken. Każdy dział odpowiada za wyraźnie określoną część zlecenia i jest wspierany międzynarodowo przez wskazanego partnera z naszej sieci.",
  spLabel: "Partnerzy w centrum uwagi",
  spTitle: "Rozmawiaj bezpośrednio z partnerem dla swojego rynku",
  spLead: "Każdy rynek ma wskazanego partnera. Napisz bezpośrednio na WhatsAppie — bez formularzy i bez call center.",
  spWa: "WhatsApp {name}",
  viewMarket: "Strona rynku",
  mKicker: "Rynek",
  mPrefix: "Kadry i usługi przemysłowe —",
  mFacts: "W skrócie",
  fCoverage: "Zakres",
  fCoverageT: "Specjaliści i wykwalifikowane kadry, wsparcie BHP",
  fContact: "Kontakt lokalny",
  fHq: "Siedziba",
  fHqT: "Sandviken, Szwecja",
  fLang: "Języki pracy",
  fLangT: "Angielski + język lokalny",
  mServices: "Co zapewniamy — {country}",
  services: [
    { title: "Specjaliści i kadra techniczna", text: "Specjaliści BHP i SHEQ, kierownictwo projektu i budowy, inżynieria, jakość, planowanie i kontrola projektu dla projektów na tym rynku." },
    { title: "Wykwalifikowane kadry certyfikowane", text: "Certyfikowane zawody dla budownictwa, przemysłu, mechaniki, elektryki, konstrukcji stalowych i prac wykończeniowych — mobilizowane do projektów na tym rynku." },
    { title: "Wsparcie doradcze BHP", text: "Doradztwo BHP zgodne z ISO 45001:2018, dokumentacja i wsparcie na budowie dla klientów działających na tym rynku." },
  ],
  mContactT: "Kontakt lokalny — {country}",
  mContactL: "Porozmawiaj z nami o zapotrzebowaniu na tym rynku — telefonicznie, przez WhatsApp lub e-mailem. Zapytania trafiają do partnera odpowiedzialnego za ten rynek.",
  mCta: "Zapytanie o pracowników — {country}",
  mMapCta: "Zobacz wszystkie rynki na mapie",
  mDisc: "The Nordic Vision działa z siedziby w Sandviken w Szwecji i obsługuje klientów na tym rynku ({country}) poprzez własny zespół oraz międzynarodową sieć partnerów. Nie twierdzimy, że posiadamy biura fizyczne poza Szwecją.",
  pLabel: "Typowe zakresy",
  pTitle: "Zakresy projektów, które wspieramy — {country}",
  pLead: "Przykłady prac, które zwykle wspierają nasi specjaliści i wykwalifikowane kadry na tym rynku. To typowe zakresy, a nie referencje klientów.",
  rTitle: "Mobilizowane stanowiska — {country}",
  rWhite: "Stanowiska specjalistyczne i techniczne",
  rBlue: "Zawody wykwalifikowane i stanowiska na budowie",
  iTitle: "Sektory, które obsługujemy — {country}",
});

const es = L({
  d: [
    ["Operaciones y proyectos", "Entregar proyectos con excelencia"],
    ["Suministro de personal", "Aportar a las personas adecuadas"],
    ["HSE y calidad", "Seguridad · Calidad · Cumplimiento"],
    ["Selección y adquisición de talento", "Buscar. Evaluar. Incorporar."],
    ["Finanzas y administración", "Solidez financiera. Soporte operativo."],
    ["Desarrollo de negocio", "Crear relaciones y nuevas oportunidades"],
  ],
  sLabel: "Cómo estamos organizados",
  sTitle: "Una estructura, tres niveles",
  sLead: "Cada solicitud sigue el mismo camino: la asume nuestra sede en Sandviken, la gestiona uno de los seis departamentos funcionales y se entrega localmente a través de nuestra red internacional de socios.",
  l1t: "Sede — Sandviken, Suecia",
  l1x: "La dirección, los contratos y la responsabilidad del cliente están en manos del Director General / CEO en Suecia. Cada proyecto tiene un responsable único.",
  l2t: "Seis departamentos funcionales",
  l2x: "Operaciones y proyectos, suministro de personal, HSE y calidad, selección y adquisición de talento, finanzas y administración y desarrollo de negocio.",
  l3t: "Red internacional de socios",
  l3x: "Socios identificados cubren el Reino Unido, Portugal, Polonia, la región nórdica y Arabia Saudí — conocimiento e idioma local, un solo contrato con The Nordic Vision.",
  flow: ["Solicitud del cliente", "Responsabilidad de la sede", "Gestión del departamento", "Entrega del socio local", "Movilización en obra"],
  deptPartner: "Socio responsable",
  deptHq: "Sede",
  orgCta: "Ver los seis departamentos",
  networkCta: "Conocer la red de socios",
  partnerDepts: "Departamentos que apoya",
  aLabel: "Sobre la red",
  aTitle: "Cómo funciona nuestra estructura internacional",
  p1: "The Nordic Vision es una empresa sueca con una única sede responsable en Sandviken. El trabajo se organiza en seis departamentos — operaciones y proyectos, suministro de personal, HSE y calidad, selección y adquisición de talento, finanzas y administración y desarrollo de negocio — y cada departamento cuenta con el apoyo internacional de un socio identificado.",
  p2: "Eso le da conocimiento del mercado e idioma local en cada mercado en el que trabajamos, un único punto de responsabilidad en Suecia y un solo contrato con The Nordic Vision. Nuestros socios cubren desarrollo de negocio, soluciones de personal, HSE, selección y operaciones de proyecto en Europa, Reino Unido, Portugal, Polonia, la región nórdica y mercados internacionales seleccionados.",
  orgLead: "Nivel dos de nuestra estructura: seis departamentos funcionales en la sede de Sandviken. Cada departamento asume una parte clara de su proyecto y cuenta con el apoyo internacional de un socio identificado de nuestra red.",
  spLabel: "Socios destacados",
  spTitle: "Hable directamente con el socio de su mercado",
  spLead: "Cada mercado tiene un socio identificado. Escríbale directamente por WhatsApp — sin formularios ni centros de llamadas.",
  spWa: "WhatsApp {name}",
  viewMarket: "Página del mercado",
  mKicker: "Mercado",
  mPrefix: "Personal y servicios industriales —",
  mFacts: "En resumen",
  fCoverage: "Cobertura",
  fCoverageT: "Profesionales y mano de obra cualificada, apoyo HSE",
  fContact: "Contacto local",
  fHq: "Sede",
  fHqT: "Sandviken, Suecia",
  fLang: "Idiomas de trabajo",
  fLangT: "Inglés + idioma local",
  mServices: "Lo que ofrecemos — {country}",
  services: [
    { title: "Profesionales y perfiles técnicos", text: "Especialistas en HSE y SHEQ, dirección de obra y proyecto, ingeniería, calidad, planificación y control de proyecto para proyectos en este mercado." },
    { title: "Mano de obra cualificada y certificada", text: "Oficios certificados para construcción, industria, mecánica, electricidad, estructura metálica y acabados especializados — movilizados para proyectos en este mercado." },
    { title: "Apoyo de consultoría HSE", text: "Consultoría HSE alineada con ISO 45001:2018, documentación y apoyo en obra para clientes que operan en este mercado." },
  ],
  mContactT: "Contacto local — {country}",
  mContactL: "Hable con nosotros sobre una necesidad en este mercado — por teléfono, WhatsApp o correo. Las solicitudes se dirigen al socio responsable del mercado.",
  mCta: "Solicitar personal — {country}",
  mMapCta: "Ver todos los mercados en el mapa",
  mDisc: "The Nordic Vision opera desde su sede en Sandviken (Suecia) y atiende a clientes en este mercado ({country}) con su propio equipo y una red internacional de socios. No se afirma tener oficinas físicas fuera de Suecia.",
  pLabel: "Alcances habituales",
  pTitle: "Alcances de proyecto que apoyamos — {country}",
  pLead: "Ejemplos del trabajo que nuestros profesionales y mano de obra cualificada apoyan habitualmente en este mercado. Son alcances típicos, no referencias de clientes.",
  rTitle: "Perfiles que movilizamos — {country}",
  rWhite: "Perfiles profesionales y técnicos",
  rBlue: "Oficios cualificados y perfiles de obra",
  iTitle: "Sectores que atendemos — {country}",
});

const nl = L({
  d: [
    ["Operations & projecten", "Projecten uitvoeren met kwaliteit"],
    ["Personeelslevering", "De juiste mensen leveren"],
    ["HSE & kwaliteit", "Veiligheid · Kwaliteit · Compliance"],
    ["Recruitment & talent acquisition", "Zoeken. Screenen. Plaatsen."],
    ["Finance & administratie", "Financiële stabiliteit. Operationele ondersteuning."],
    ["Business development", "Relaties opbouwen en kansen creëren"],
  ],
  sLabel: "Hoe wij zijn georganiseerd",
  sTitle: "Één structuur, drie lagen",
  sLead: "Elke aanvraag volgt dezelfde route: ons hoofdkantoor in Sandviken is eigenaar, een van zes functionele afdelingen behandelt de aanvraag en de uitvoering gebeurt lokaal via ons internationale partnernetwerk.",
  l1t: "Hoofdkantoor — Sandviken, Zweden",
  l1x: "Leiding, contracten en klantverantwoordelijkheid liggen bij de Managing Director / CEO in Zweden. Elke opdracht heeft één verantwoordelijke eigenaar.",
  l2t: "Zes functionele afdelingen",
  l2x: "Operations & projecten, personeelslevering, HSE & kwaliteit, recruitment & talent acquisition, finance & administratie en business development.",
  l3t: "Internationaal partnernetwerk",
  l3x: "Aangewezen partners dekken het Verenigd Koninkrijk, Portugal, Polen, de Noordse regio en Saoedi-Arabië — lokale marktkennis en taal, één contract met The Nordic Vision.",
  flow: ["Aanvraag van de klant", "Eigendom hoofdkantoor", "Afhandeling door afdeling", "Uitvoering door lokale partner", "Mobilisatie op locatie"],
  deptPartner: "Partnerdekking",
  deptHq: "Hoofdkantoor",
  orgCta: "Bekijk de zes afdelingen",
  networkCta: "Ontmoet het partnernetwerk",
  partnerDepts: "Ondersteunde afdelingen",
  aLabel: "Over het netwerk",
  aTitle: "Hoe onze internationale structuur werkt",
  p1: "The Nordic Vision is een Zweeds bedrijf met één verantwoordelijk hoofdkantoor in Sandviken. Het werk is georganiseerd in zes afdelingen — operations & projecten, personeelslevering, HSE & kwaliteit, recruitment & talent acquisition, finance & administratie en business development — en elke afdeling wordt internationaal ondersteund door een aangewezen partner.",
  p2: "Dat geeft u lokale marktkennis en taal in elke markt waarin wij werken, één aanspreekpunt in Zweden en één contract met The Nordic Vision. Onze partners dekken business development, personeelsoplossingen, HSE, recruitment en projectuitvoering in Europa, het Verenigd Koninkrijk, Portugal, Polen, de Noordse regio en geselecteerde internationale markten.",
  orgLead: "Laag twee van onze structuur: zes functionele afdelingen op het hoofdkantoor in Sandviken. Elke afdeling is verantwoordelijk voor een duidelijk deel van uw opdracht en wordt internationaal ondersteund door een aangewezen partner uit ons netwerk.",
  spLabel: "Partners in de spotlight",
  spTitle: "Praat direct met de partner voor uw markt",
  spLead: "Elke markt heeft een aangewezen partner. Stuur direct een WhatsApp-bericht — geen formulieren, geen callcenter.",
  spWa: "WhatsApp {name}",
  viewMarket: "Marktpagina",
  mKicker: "Markt",
  mPrefix: "Personeel & industriële diensten —",
  mFacts: "In één oogopslag",
  fCoverage: "Dekking",
  fCoverageT: "Specialisten & vakmensen, HSE-ondersteuning",
  fContact: "Lokaal contact",
  fHq: "Hoofdkantoor",
  fHqT: "Sandviken, Zweden",
  fLang: "Werktalen",
  fLangT: "Engels + lokale taal",
  mServices: "Wat wij bieden — {country}",
  services: [
    { title: "Specialisten & technisch personeel", text: "HSE- en SHEQ-specialisten, project- en uitvoeringsleiding, engineering, kwaliteit, planning en projectbeheersing voor projecten in deze markt." },
    { title: "Gecertificeerde vakmensen", text: "Gecertificeerde vakmensen voor bouw, industrie, mechanisch, elektrisch, staal en specialistische afbouw — gemobiliseerd voor projecten in deze markt." },
    { title: "HSE-consultancy ondersteuning", text: "HSE-consultancy volgens ISO 45001:2018, documentatie en ondersteuning op locatie voor klanten in deze markt." },
  ],
  mContactT: "Lokaal contact — {country}",
  mContactL: "Bespreek uw behoefte in deze markt — telefonisch, via WhatsApp of e-mail. Aanvragen gaan naar de partner die verantwoordelijk is voor deze markt.",
  mCta: "Personeel aanvragen — {country}",
  mMapCta: "Bekijk alle markten op de kaart",
  mDisc: "The Nordic Vision werkt vanuit het hoofdkantoor in Sandviken, Zweden en ondersteunt klanten in deze markt ({country}) met het eigen team en een internationaal partnernetwerk. Er worden geen fysieke kantoren buiten Zweden geclaimd.",
  pLabel: "Typische scopes",
  pTitle: "Projectscopes die wij ondersteunen — {country}",
  pLead: "Voorbeelden van werk dat onze specialisten en vakmensen doorgaans ondersteunen in deze markt. Dit zijn typische scopes, geen klantreferenties.",
  rTitle: "Functies die wij mobiliseren — {country}",
  rWhite: "Specialistische & technische functies",
  rBlue: "Vakmensen & functies op locatie",
  iTitle: "Sectoren die wij bedienen — {country}",
});

const fr = L({
  d: [
    ["Opérations & projets", "Livrer les projets avec excellence"],
    ["Fourniture de main-d'œuvre", "Apporter les bonnes personnes"],
    ["HSE & qualité", "Sécurité · Qualité · Conformité"],
    ["Recrutement & acquisition de talents", "Chercher. Évaluer. Placer."],
    ["Finance & administration", "Solidité financière. Appui opérationnel."],
    ["Développement commercial", "Créer des relations et des opportunités"],
  ],
  sLabel: "Notre organisation",
  sTitle: "Une structure, trois niveaux",
  sLead: "Chaque demande suit le même chemin : elle est prise en charge par notre siège de Sandviken, traitée par l'un des six départements fonctionnels, puis livrée localement via notre réseau international de partenaires.",
  l1t: "Siège — Sandviken, Suède",
  l1x: "La direction, les contrats et la responsabilité client relèvent du Directeur Général / CEO en Suède. Chaque mission a un responsable unique.",
  l2t: "Six départements fonctionnels",
  l2x: "Opérations & projets, fourniture de main-d'œuvre, HSE & qualité, recrutement & acquisition de talents, finance & administration et développement commercial.",
  l3t: "Réseau international de partenaires",
  l3x: "Des partenaires nommés couvrent le Royaume-Uni, le Portugal, la Pologne, la région nordique et l'Arabie saoudite — connaissance et langue locales, un seul contrat avec The Nordic Vision.",
  flow: ["Demande du client", "Prise en charge par le siège", "Traitement par le département", "Livraison par le partenaire local", "Mobilisation sur site"],
  deptPartner: "Partenaire référent",
  deptHq: "Siège",
  orgCta: "Voir les six départements",
  networkCta: "Découvrir le réseau de partenaires",
  partnerDepts: "Départements soutenus",
  aLabel: "À propos du réseau",
  aTitle: "Comment fonctionne notre structure internationale",
  p1: "The Nordic Vision est une société suédoise avec un siège unique et responsable à Sandviken. Le travail est organisé en six départements — opérations & projets, fourniture de main-d'œuvre, HSE & qualité, recrutement & acquisition de talents, finance & administration et développement commercial — et chaque département est soutenu à l'international par un partenaire nommé.",
  p2: "Cela vous apporte une connaissance du marché et de la langue locale sur chaque marché où nous intervenons, un point de responsabilité unique en Suède et un seul contrat avec The Nordic Vision. Nos partenaires couvrent le développement commercial, les solutions de main-d'œuvre, le HSE, le recrutement et les opérations de projet en Europe, au Royaume-Uni, au Portugal, en Pologne, dans la région nordique et sur des marchés internationaux sélectionnés.",
  orgLead: "Niveau deux de notre structure : six départements fonctionnels au siège de Sandviken. Chaque département porte une partie claire de votre mission et est soutenu à l'international par un partenaire nommé de notre réseau.",
  spLabel: "Partenaires à l'honneur",
  spTitle: "Parlez directement au partenaire de votre marché",
  spLead: "Chaque marché dispose d'un partenaire nommé. Écrivez-lui directement sur WhatsApp — sans formulaire, sans centre d'appels.",
  spWa: "WhatsApp {name}",
  viewMarket: "Page du marché",
  mKicker: "Marché",
  mPrefix: "Main-d'œuvre & services industriels —",
  mFacts: "En bref",
  fCoverage: "Couverture",
  fCoverageT: "Cadres & main-d'œuvre qualifiée, appui HSE",
  fContact: "Contact local",
  fHq: "Siège",
  fHqT: "Sandviken, Suède",
  fLang: "Langues de travail",
  fLangT: "Anglais + langue locale",
  mServices: "Ce que nous proposons — {country}",
  services: [
    { title: "Cadres et profils techniques", text: "Spécialistes HSE et SHEQ, direction de projet et de chantier, ingénierie, qualité, planification et contrôle de projet pour les projets de ce marché." },
    { title: "Main-d'œuvre qualifiée et certifiée", text: "Métiers certifiés pour la construction, l'industrie, la mécanique, l'électricité, la charpente métallique et les finitions spécialisées — mobilisés pour les projets de ce marché." },
    { title: "Appui conseil HSE", text: "Conseil HSE aligné sur l'ISO 45001:2018, documentation et appui sur site pour les clients actifs sur ce marché." },
  ],
  mContactT: "Contact local — {country}",
  mContactL: "Parlons de votre besoin sur ce marché — par téléphone, WhatsApp ou e-mail. Les demandes sont transmises au partenaire responsable du marché.",
  mCta: "Demander du personnel — {country}",
  mMapCta: "Voir tous les marchés sur la carte",
  mDisc: "The Nordic Vision opère depuis son siège de Sandviken, en Suède, et accompagne ses clients sur ce marché ({country}) avec sa propre équipe et un réseau international de partenaires. Aucun bureau physique hors de Suède n'est revendiqué.",
  pLabel: "Périmètres types",
  pTitle: "Périmètres de projet que nous soutenons — {country}",
  pLead: "Exemples de travaux que nos cadres et notre main-d'œuvre qualifiée soutiennent habituellement sur ce marché. Ce sont des périmètres types, pas des références clients.",
  rTitle: "Postes que nous mobilisons — {country}",
  rWhite: "Postes cadres et techniques",
  rBlue: "Métiers qualifiés et postes de chantier",
  iTitle: "Secteurs que nous servons — {country}",
});

const de = L({
  d: [
    ["Operations & Projekte", "Projekte mit Exzellenz umsetzen"],
    ["Personalbereitstellung", "Die richtigen Menschen bereitstellen"],
    ["HSE & Qualität", "Sicherheit · Qualität · Compliance"],
    ["Recruiting & Talent Acquisition", "Finden. Prüfen. Besetzen."],
    ["Finanzen & Verwaltung", "Finanzielle Stärke. Operative Unterstützung."],
    ["Business Development", "Beziehungen aufbauen, Chancen schaffen"],
  ],
  sLabel: "So sind wir organisiert",
  sTitle: "Eine Struktur, drei Ebenen",
  sLead: "Jede Anfrage nimmt denselben Weg: Sie liegt in der Verantwortung unserer Zentrale in Sandviken, wird von einer von sechs Fachabteilungen bearbeitet und lokal über unser internationales Partnernetzwerk umgesetzt.",
  l1t: "Zentrale — Sandviken, Schweden",
  l1x: "Leitung, Verträge und Kundenverantwortung liegen beim Managing Director / CEO in Schweden. Jedes Projekt hat einen verantwortlichen Ansprechpartner.",
  l2t: "Sechs Fachabteilungen",
  l2x: "Operations & Projekte, Personalbereitstellung, HSE & Qualität, Recruiting & Talent Acquisition, Finanzen & Verwaltung und Business Development.",
  l3t: "Internationales Partnernetzwerk",
  l3x: "Benannte Partner betreuen Großbritannien, Portugal, Polen, die nordische Region und Saudi-Arabien — lokale Marktkenntnis und Sprache, ein Vertrag mit The Nordic Vision.",
  flow: ["Kundenanfrage", "Verantwortung Zentrale", "Bearbeitung durch Abteilung", "Umsetzung durch lokalen Partner", "Mobilisierung auf der Baustelle"],
  deptPartner: "Partnerbetreuung",
  deptHq: "Zentrale",
  orgCta: "Die sechs Abteilungen ansehen",
  networkCta: "Partnernetzwerk kennenlernen",
  partnerDepts: "Unterstützte Abteilungen",
  aLabel: "Über das Netzwerk",
  aTitle: "So funktioniert unsere internationale Struktur",
  p1: "The Nordic Vision ist ein schwedisches Unternehmen mit einer einzigen verantwortlichen Zentrale in Sandviken. Die Arbeit ist in sechs Abteilungen organisiert — Operations & Projekte, Personalbereitstellung, HSE & Qualität, Recruiting & Talent Acquisition, Finanzen & Verwaltung und Business Development — und jede Abteilung wird international von einem benannten Partner unterstützt.",
  p2: "Das bedeutet lokale Marktkenntnis und Sprache in jedem Markt, in dem wir arbeiten, einen verantwortlichen Ansprechpunkt in Schweden und einen Vertrag mit The Nordic Vision. Unsere Partner decken Business Development, Personallösungen, HSE, Recruiting und Projektbetrieb in Europa, Großbritannien, Portugal, Polen, der nordischen Region und ausgewählten internationalen Märkten ab.",
  orgLead: "Ebene zwei unserer Struktur: sechs Fachabteilungen in der Zentrale in Sandviken. Jede Abteilung verantwortet einen klar abgegrenzten Teil Ihres Projekts und wird international von einem benannten Partner aus unserem Netzwerk unterstützt.",
  spLabel: "Partner im Fokus",
  spTitle: "Sprechen Sie direkt mit dem Partner für Ihren Markt",
  spLead: "Jeder Markt hat einen benannten Partner. Schreiben Sie direkt per WhatsApp — keine Formulare, kein Callcenter.",
  spWa: "WhatsApp {name}",
  viewMarket: "Marktseite",
  mKicker: "Markt",
  mPrefix: "Fachkräfte & Industriedienstleistungen —",
  mFacts: "Auf einen Blick",
  fCoverage: "Leistungsumfang",
  fCoverageT: "Fachkräfte & qualifizierte Gewerke, HSE-Unterstützung",
  fContact: "Lokaler Kontakt",
  fHq: "Zentrale",
  fHqT: "Sandviken, Schweden",
  fLang: "Arbeitssprachen",
  fLangT: "Englisch + Landessprache",
  mServices: "Unser Angebot — {country}",
  services: [
    { title: "Fach- und Führungskräfte", text: "HSE- und SHEQ-Spezialisten, Projekt- und Bauleitung, Engineering, Qualität, Planung und Projektsteuerung für Projekte in diesem Markt." },
    { title: "Qualifizierte, zertifizierte Gewerke", text: "Zertifizierte Gewerke für Bau, Industrie, Mechanik, Elektro, Stahlbau und spezialisierte Ausbauleistungen — mobilisiert für Projekte in diesem Markt." },
    { title: "HSE-Beratungsunterstützung", text: "HSE-Beratung nach ISO 45001:2018, Dokumentation und Unterstützung vor Ort für Kunden in diesem Markt." },
  ],
  mContactT: "Lokaler Kontakt — {country}",
  mContactL: "Sprechen Sie mit uns über Ihren Bedarf in diesem Markt — telefonisch, per WhatsApp oder E-Mail. Anfragen gehen an den verantwortlichen Partner.",
  mCta: "Fachkräfte anfragen — {country}",
  mMapCta: "Alle Märkte auf der Karte ansehen",
  mDisc: "The Nordic Vision arbeitet von der Zentrale in Sandviken, Schweden, und unterstützt Kunden in diesem Markt ({country}) mit dem eigenen Team und einem internationalen Partnernetzwerk. Physische Büros außerhalb Schwedens werden nicht behauptet.",
  pLabel: "Typische Leistungsbilder",
  pTitle: "Projektumfänge, die wir unterstützen — {country}",
  pLead: "Beispiele für Arbeiten, die unsere Fachkräfte und Gewerke in diesem Markt typischerweise unterstützen. Es handelt sich um typische Leistungsbilder, nicht um Kundenreferenzen.",
  rTitle: "Positionen, die wir mobilisieren — {country}",
  rWhite: "Fach- und technische Positionen",
  rBlue: "Qualifizierte Gewerke & Baustellenpositionen",
  iTitle: "Branchen, die wir bedienen — {country}",
});

const da = L({
  d: [
    ["Drift & projekter", "Vi leverer projekter med kvalitet"],
    ["Bemanding", "Vi finder de rette folk"],
    ["HSE & kvalitet", "Sikkerhed · Kvalitet · Compliance"],
    ["Rekruttering & talent acquisition", "Søge. Screene. Placere."],
    ["Økonomi & administration", "Finansiel styrke. Operationel støtte."],
    ["Forretningsudvikling", "Vi bygger relationer og skaber muligheder"],
  ],
  sLabel: "Sådan er vi organiseret",
  sTitle: "Én struktur, tre lag",
  sLead: "Hver forespørgsel følger samme vej: den ejes af vores hovedkontor i Sandviken, håndteres af en af seks funktionsafdelinger og leveres lokalt gennem vores internationale partnernetværk.",
  l1t: "Hovedkontor — Sandviken, Sverige",
  l1x: "Ledelse, kontrakter og kundeansvar ligger hos den administrerende direktør / CEO i Sverige. Hver opgave har én ansvarlig ejer.",
  l2t: "Seks funktionsafdelinger",
  l2x: "Drift & projekter, bemanding, HSE & kvalitet, rekruttering & talent acquisition, økonomi & administration samt forretningsudvikling.",
  l3t: "Internationalt partnernetværk",
  l3x: "Navngivne partnere dækker Storbritannien, Portugal, Polen, Norden og Saudi-Arabien — lokal markedskendskab og sprog, én kontrakt med The Nordic Vision.",
  flow: ["Kundeforespørgsel", "Ansvar hos hovedkontoret", "Håndtering i afdelingen", "Levering via lokal partner", "Mobilisering på pladsen"],
  deptPartner: "Partneransvar",
  deptHq: "Hovedkontor",
  orgCta: "Se de seks afdelinger",
  networkCta: "Mød partnernetværket",
  partnerDepts: "Understøttede afdelinger",
  aLabel: "Om netværket",
  aTitle: "Sådan fungerer vores internationale struktur",
  p1: "The Nordic Vision er et svensk selskab med ét ansvarligt hovedkontor i Sandviken. Arbejdet er organiseret i seks afdelinger — drift & projekter, bemanding, HSE & kvalitet, rekruttering & talent acquisition, økonomi & administration samt forretningsudvikling — og hver afdeling understøttes internationalt af en navngiven partner.",
  p2: "Det giver dig lokal markedskendskab og lokalt sprog på hvert marked, vi arbejder på, ét ansvarligt kontaktpunkt i Sverige og én kontrakt med The Nordic Vision. Vores partnere dækker forretningsudvikling, bemandingsløsninger, HSE, rekruttering og projektdrift i Europa, Storbritannien, Portugal, Polen, Norden og udvalgte internationale markeder.",
  orgLead: "Lag to i vores struktur: seks funktionsafdelinger på hovedkontoret i Sandviken. Hver afdeling ejer en klar del af din opgave og understøttes internationalt af en navngiven partner fra vores netværk.",
  spLabel: "Partnere i fokus",
  spTitle: "Tal direkte med partneren for dit marked",
  spLead: "Hvert marked har en navngiven partner. Skriv direkte på WhatsApp — ingen formularer, intet callcenter.",
  spWa: "WhatsApp {name}",
  viewMarket: "Markedsside",
  mKicker: "Marked",
  mPrefix: "Bemanding & industriservice —",
  mFacts: "Kort fortalt",
  fCoverage: "Dækning",
  fCoverageT: "Specialister & faglærte, HSE-støtte",
  fContact: "Lokal kontakt",
  fHq: "Hovedkontor",
  fHqT: "Sandviken, Sverige",
  fLang: "Arbejdssprog",
  fLangT: "Engelsk + lokalt sprog",
  mServices: "Det tilbyder vi — {country}",
  services: [
    { title: "Specialister & tekniske profiler", text: "HSE- og SHEQ-specialister, projekt- og byggeledelse, engineering, kvalitet, planlægning og projektstyring til projekter på dette marked." },
    { title: "Certificeret faglært arbejdskraft", text: "Certificerede fag til byggeri, industri, mekanik, el, stål og specialiserede færdiggørelsesopgaver — mobiliseret til projekter på dette marked." },
    { title: "HSE-rådgivningsstøtte", text: "HSE-rådgivning efter ISO 45001:2018, dokumentation og støtte på pladsen for kunder på dette marked." },
  ],
  mContactT: "Lokal kontakt — {country}",
  mContactL: "Tal med os om et behov på dette marked — via telefon, WhatsApp eller e-mail. Forespørgsler sendes til den ansvarlige partner.",
  mCta: "Anmod om arbejdskraft — {country}",
  mMapCta: "Se alle markeder på kortet",
  mDisc: "The Nordic Vision arbejder fra hovedkontoret i Sandviken, Sverige, og støtter kunder på dette marked ({country}) med eget team og et internationalt partnernetværk. Der påstås ikke fysiske kontorer uden for Sverige.",
  pLabel: "Typiske opgaver",
  pTitle: "Projektomfang vi støtter — {country}",
  pLead: "Eksempler på arbejde, som vores specialister og faglærte typisk støtter på dette marked. Det er typiske opgavetyper, ikke kundereferencer.",
  rTitle: "Roller vi mobiliserer — {country}",
  rWhite: "Specialist- & tekniske roller",
  rBlue: "Faglærte & roller på pladsen",
  iTitle: "Brancher vi betjener — {country}",
});

const no = L({
  d: [
    ["Drift & prosjekter", "Vi leverer prosjekter med kvalitet"],
    ["Bemanning", "Vi finner de rette folkene"],
    ["HMS & kvalitet", "Sikkerhet · Kvalitet · Etterlevelse"],
    ["Rekruttering & talent acquisition", "Søke. Screene. Plassere."],
    ["Økonomi & administrasjon", "Finansiell styrke. Operativ støtte."],
    ["Forretningsutvikling", "Vi bygger relasjoner og skaper muligheter"],
  ],
  sLabel: "Slik er vi organisert",
  sTitle: "Én struktur, tre nivåer",
  sLead: "Hver forespørsel følger samme vei: den eies av hovedkontoret vårt i Sandviken, håndteres av en av seks funksjonsavdelinger og leveres lokalt gjennom vårt internasjonale partnernettverk.",
  l1t: "Hovedkontor — Sandviken, Sverige",
  l1x: "Ledelse, kontrakter og kundeansvar ligger hos administrerende direktør / CEO i Sverige. Hvert oppdrag har én ansvarlig eier.",
  l2t: "Seks funksjonsavdelinger",
  l2x: "Drift & prosjekter, bemanning, HMS & kvalitet, rekruttering & talent acquisition, økonomi & administrasjon og forretningsutvikling.",
  l3t: "Internasjonalt partnernettverk",
  l3x: "Navngitte partnere dekker Storbritannia, Portugal, Polen, Norden og Saudi-Arabia — lokal markedskunnskap og språk, én kontrakt med The Nordic Vision.",
  flow: ["Kundeforespørsel", "Ansvar hos hovedkontoret", "Håndtering i avdelingen", "Levering via lokal partner", "Mobilisering på anlegget"],
  deptPartner: "Partneransvar",
  deptHq: "Hovedkontor",
  orgCta: "Se de seks avdelingene",
  networkCta: "Møt partnernettverket",
  partnerDepts: "Avdelinger som støttes",
  aLabel: "Om nettverket",
  aTitle: "Slik fungerer vår internasjonale struktur",
  p1: "The Nordic Vision er et svensk selskap med ett ansvarlig hovedkontor i Sandviken. Arbeidet er organisert i seks avdelinger — drift & prosjekter, bemanning, HMS & kvalitet, rekruttering & talent acquisition, økonomi & administrasjon og forretningsutvikling — og hver avdeling støttes internasjonalt av en navngitt partner.",
  p2: "Det gir deg lokal markedskunnskap og lokalt språk i hvert marked vi jobber i, ett ansvarlig kontaktpunkt i Sverige og én kontrakt med The Nordic Vision. Partnerne våre dekker forretningsutvikling, bemanningsløsninger, HMS, rekruttering og prosjektdrift i Europa, Storbritannia, Portugal, Polen, Norden og utvalgte internasjonale markeder.",
  orgLead: "Nivå to i strukturen vår: seks funksjonsavdelinger ved hovedkontoret i Sandviken. Hver avdeling eier en klar del av oppdraget ditt og støttes internasjonalt av en navngitt partner fra nettverket vårt.",
  spLabel: "Partnere i fokus",
  spTitle: "Snakk direkte med partneren for markedet ditt",
  spLead: "Hvert marked har en navngitt partner. Send melding direkte på WhatsApp — ingen skjemaer, ingen kundesenter.",
  spWa: "WhatsApp {name}",
  viewMarket: "Markedsside",
  mKicker: "Marked",
  mPrefix: "Bemanning & industritjenester —",
  mFacts: "Kort oppsummert",
  fCoverage: "Dekning",
  fCoverageT: "Spesialister & fagarbeidere, HMS-støtte",
  fContact: "Lokal kontakt",
  fHq: "Hovedkontor",
  fHqT: "Sandviken, Sverige",
  fLang: "Arbeidsspråk",
  fLangT: "Engelsk + lokalt språk",
  mServices: "Dette tilbyr vi — {country}",
  services: [
    { title: "Spesialister & tekniske roller", text: "HMS- og SHEQ-spesialister, prosjekt- og anleggsledelse, engineering, kvalitet, planlegging og prosjektstyring for prosjekter i dette markedet." },
    { title: "Sertifisert faglært arbeidskraft", text: "Sertifiserte fag for bygg, industri, mekanikk, elektro, stål og spesialiserte ferdigstillingsarbeider — mobilisert for prosjekter i dette markedet." },
    { title: "HMS-rådgivningsstøtte", text: "HMS-rådgivning i tråd med ISO 45001:2018, dokumentasjon og støtte på anlegget for kunder i dette markedet." },
  ],
  mContactT: "Lokal kontakt — {country}",
  mContactL: "Snakk med oss om et behov i dette markedet — på telefon, WhatsApp eller e-post. Forespørsler går til partneren som har ansvar for markedet.",
  mCta: "Be om arbeidskraft — {country}",
  mMapCta: "Se alle markeder på kartet",
  mDisc: "The Nordic Vision arbeider fra hovedkontoret i Sandviken i Sverige og støtter kunder i dette markedet ({country}) med eget team og et internasjonalt partnernettverk. Det hevdes ikke fysiske kontorer utenfor Sverige.",
  pLabel: "Typiske oppdrag",
  pTitle: "Prosjektomfang vi støtter — {country}",
  pLead: "Eksempler på arbeid som spesialistene og fagarbeiderne våre vanligvis støtter i dette markedet. Dette er typiske oppdragstyper, ikke kundereferanser.",
  rTitle: "Roller vi mobiliserer — {country}",
  rWhite: "Spesialist- & tekniske roller",
  rBlue: "Fagarbeidere & roller på anlegget",
  iTitle: "Bransjer vi betjener — {country}",
});

const fi = L({
  d: [
    ["Operaatiot & projektit", "Toteutamme projektit laadukkaasti"],
    ["Työvoiman toimitus", "Tuomme oikeat ihmiset"],
    ["HSE & laatu", "Turvallisuus · Laatu · Vaatimustenmukaisuus"],
    ["Rekrytointi & osaajahankinta", "Etsimme. Arvioimme. Sijoitamme."],
    ["Talous & hallinto", "Taloudellinen vakaus. Operatiivinen tuki."],
    ["Liiketoiminnan kehitys", "Rakennamme suhteita ja luomme mahdollisuuksia"],
  ],
  sLabel: "Näin olemme järjestäytyneet",
  sTitle: "Yksi rakenne, kolme tasoa",
  sLead: "Jokainen kysely kulkee samaa reittiä: siitä vastaa Sandvikenin pääkonttorimme, sen käsittelee yksi kuudesta toiminnallisesta osastosta ja toimitus tapahtuu paikallisesti kansainvälisen kumppaniverkostomme kautta.",
  l1t: "Pääkonttori — Sandviken, Ruotsi",
  l1x: "Johto, sopimukset ja asiakasvastuu ovat toimitusjohtajalla Ruotsissa. Jokaisella toimeksiannolla on yksi vastuullinen omistaja.",
  l2t: "Kuusi toiminnallista osastoa",
  l2x: "Operaatiot & projektit, työvoiman toimitus, HSE & laatu, rekrytointi & osaajahankinta, talous & hallinto sekä liiketoiminnan kehitys.",
  l3t: "Kansainvälinen kumppaniverkosto",
  l3x: "Nimetyt kumppanit kattavat Britannian, Portugalin, Puolan, Pohjoismaat ja Saudi-Arabian — paikallinen markkinatuntemus ja kieli, yksi sopimus The Nordic Visionin kanssa.",
  flow: ["Asiakkaan kysely", "Pääkonttorin vastuu", "Osaston käsittely", "Paikallisen kumppanin toimitus", "Mobilisointi työmaalle"],
  deptPartner: "Kumppanin vastuu",
  deptHq: "Pääkonttori",
  orgCta: "Katso kuusi osastoa",
  networkCta: "Tutustu kumppaniverkostoon",
  partnerDepts: "Tuetut osastot",
  aLabel: "Tietoa verkostosta",
  aTitle: "Näin kansainvälinen rakenteemme toimii",
  p1: "The Nordic Vision on ruotsalainen yritys, jolla on yksi vastuullinen pääkonttori Sandvikenissa. Työ on järjestetty kuuteen osastoon — operaatiot & projektit, työvoiman toimitus, HSE & laatu, rekrytointi & osaajahankinta, talous & hallinto sekä liiketoiminnan kehitys — ja jokaista osastoa tukee kansainvälisesti nimetty kumppani.",
  p2: "Näin saat paikallisen markkinatuntemuksen ja kielen jokaisella markkinalla, jolla toimimme, yhden vastuupisteen Ruotsissa ja yhden sopimuksen The Nordic Visionin kanssa. Kumppanimme kattavat liiketoiminnan kehityksen, työvoimaratkaisut, HSE:n, rekrytoinnin ja projektitoiminnan Euroopassa, Britanniassa, Portugalissa, Puolassa, Pohjoismaissa ja valituilla kansainvälisillä markkinoilla.",
  orgLead: "Rakenteemme toinen taso: kuusi toiminnallista osastoa Sandvikenin pääkonttorissa. Jokainen osasto vastaa selkeästä osasta toimeksiantoasi ja saa kansainvälistä tukea nimetyltä kumppanilta.",
  spLabel: "Kumppanit esillä",
  spTitle: "Keskustele suoraan markkinasi kumppanin kanssa",
  spLead: "Jokaisella markkinalla on nimetty kumppani. Lähetä viesti suoraan WhatsAppissa — ei lomakkeita, ei puhelinkeskusta.",
  spWa: "WhatsApp {name}",
  viewMarket: "Markkinasivu",
  mKicker: "Markkina",
  mPrefix: "Työvoima & teollisuuspalvelut —",
  mFacts: "Lyhyesti",
  fCoverage: "Kattavuus",
  fCoverageT: "Asiantuntijat & ammattityövoima, HSE-tuki",
  fContact: "Paikallinen yhteystieto",
  fHq: "Pääkonttori",
  fHqT: "Sandviken, Ruotsi",
  fLang: "Työskentelykielet",
  fLangT: "Englanti + paikallinen kieli",
  mServices: "Mitä tarjoamme — {country}",
  services: [
    { title: "Asiantuntijat ja tekniset roolit", text: "HSE- ja SHEQ-asiantuntijat, projekti- ja työmaajohto, suunnittelu, laatu ja projektinohjaus tämän markkinan projekteihin." },
    { title: "Sertifioitu ammattityövoima", text: "Sertifioidut ammattilaiset rakentamiseen, teollisuuteen, mekaniikkaan, sähköön, teräsrakenteisiin ja erikoisviimeistelyihin — mobilisoituna tämän markkinan projekteihin." },
    { title: "HSE-konsultoinnin tuki", text: "ISO 45001:2018 -mukainen HSE-konsultointi, dokumentaatio ja työmaatuki tällä markkinalla toimiville asiakkaille." },
  ],
  mContactT: "Paikallinen yhteyshenkilö — {country}",
  mContactL: "Kerro tarpeestasi tällä markkinalla — puhelimitse, WhatsAppilla tai sähköpostilla. Kyselyt ohjataan markkinasta vastaavalle kumppanille.",
  mCta: "Pyydä työvoimaa — {country}",
  mMapCta: "Katso kaikki markkinat kartalla",
  mDisc: "The Nordic Vision toimii pääkonttoristaan Sandvikenissa, Ruotsissa, ja tukee asiakkaita tällä markkinalla ({country}) omalla tiimillään ja kansainvälisellä kumppaniverkostolla. Emme väitä omistavamme fyysisiä toimistoja Ruotsin ulkopuolella.",
  pLabel: "Tyypilliset laajuudet",
  pTitle: "Projektilaajuudet joita tuemme — {country}",
  pLead: "Esimerkkejä työstä, jota asiantuntijamme ja ammattityövoimamme tyypillisesti tukevat tällä markkinalla. Nämä ovat tyypillisiä laajuuksia, eivät asiakasreferenssejä.",
  rTitle: "Roolit joita mobilisoimme — {country}",
  rWhite: "Asiantuntija- ja tekniset roolit",
  rBlue: "Ammattilaiset ja työmaaroolit",
  iTitle: "Toimialat joita palvelemme — {country}",
});

const structure2026 = { sv, pt, pl, es, nl, fr, de, da, no, fi };

export default structure2026;
